import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Divider,
    Paper,
    CircularProgress,
    Tooltip,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ImageIcon from "@mui/icons-material/Image";

const AddInvoiceOlympiad = ({ closePopup, modalData }) => {
console.log(modalData,">>>>>>>>>>>>>>>>>>>>>>")
    // ================= STATES =================

    const [oldData, setOldData] = useState([]);
    const [attachmentData, setAttachmentData] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);

    const [loading, setLoading] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(false);

    const [formData, setFormData] = useState({
        study_material_invoice_no: "",
        study_material_invoiced_amount: "",
        study_material_invoice_date: "",
    });

    // ================= GET OLD DATA =================

    useEffect(() => {
        if (modalData?.regId) {
            getOldData();
        }
    }, [modalData?.regId]);

    const getOldData = async () => {
        try {
            setHistoryLoading(true);

            const result =
                await window.Platform.database.getGenerateInvoiceDetails({
                    regId: modalData?.regId,
                    partyId : modalData?.partyId
                });

            if (result?.status) {
                setOldData(result?.data || []);
            } else {
                setOldData([]);
            }
        } catch (error) {
            console.log(error);
            setOldData([]);
        } finally {
            setHistoryLoading(false);
        }
    };

    // ================= HANDLE INPUT =================

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ================= HANDLE FILES =================

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);

        if (!files?.length) return;

        const mappedFiles = files.map((file) => ({
            file,
            name: file.name,
            type: file.type,
            preview: URL.createObjectURL(file),
        }));

        setAttachmentData((prev) => [...prev, ...mappedFiles]);
    };

    // ================= REMOVE ATTACHMENT =================

    const handleRemoveAttachment = (indexToRemove) => {
        const isConfirm = window.confirm(
            "Are you sure you want to remove this attachment?"
        );

        if (!isConfirm) return;

        setAttachmentData((prev) =>
            prev.filter((_, index) => index !== indexToRemove)
        );
    };

    // ================= VALIDATION =================

    const validateForm = () => {
        if (!formData.study_material_invoice_no) {
            window.NotificationUtils.showError(
                "Please enter invoice number"
            );
            return false;
        }

        if (!formData.study_material_invoiced_amount) {
            window.NotificationUtils.showError(
                "Please enter invoice amount"
            );
            return false;
        }

        if (!formData.study_material_invoice_date) {
            window.NotificationUtils.showError(
                "Please select invoice date"
            );
            return false;
        }

        return true;
    };

    // ================= SUBMIT =================

    const handleSubmit = async () => {
        try {

            if (!validateForm()) return;

            setLoading(true);

            // const payload = {
            //     study_material_invoice_no:
            //         formData.study_material_invoice_no,

            //     study_material_amount:
            //         formData.study_material_invoiced_amount,

            //     study_material_invoice_date:
            //         formData.study_material_invoice_date,
            // };

            const formPayload = new FormData();

            // append files
            attachmentData.forEach((fileObj) => {
                if (fileObj?.file instanceof File) {
                    formPayload.append("files", fileObj.file);
                }
            });

            formPayload.append("regId", modalData?.regId || "");
            formPayload.append("partyId", modalData?.partyId || "");
            formPayload.append("userId", modalData?.userId || "");

            formPayload.append("generate_invoice_no", formData?.study_material_invoice_no || "");
            formPayload.append("generate_invoice_amount", formData?.study_material_invoiced_amount || "");
            formPayload.append("generate_invoice_date", formData?.study_material_invoice_date || "");
            formPayload.append("so_check", modalData?.registration_type == 2 ? "no" : "yes");

            // formPayload.append(
            //     "payload",
            //     JSON.stringify(payload)
            // );

            const result =
                await window.Platform.database.createGenerateInvoice(
                    formPayload
                );

            if (result?.status) {

                window.NotificationUtils.showSuccess(
                    result?.message || "Added successfully"
                );

                // refresh old data
                getOldData();

                // reset form
                setFormData({
                    study_material_invoice_no: "",
                    study_material_invoiced_amount: "",
                    study_material_invoice_date: "",
                });

                setAttachmentData([]);

                closePopup();

            } else {

                window.NotificationUtils.showError(
                    result?.message || "Something went wrong"
                );
            }

        } catch (error) {

            console.log(error);

            window.NotificationUtils.showError(
                "Something went wrong"
            );

        } finally {
            setLoading(false);
        }
    };

    return (
        <Box p={3} position="relative">

            {/* ================= HEADER ================= */}

            <Typography
                variant="h5"
                fontWeight={700}
                textAlign={"center"}
                mb={1}
            >
                Add Invoice
            </Typography>

            <div style={{ borderBottom: "1px solid #000" }}>
                <Typography sx={{ fontSize: "15px", mb: 1 }}>
                    <b>RNO ID:</b> {modalData?.rno_id} |
                    <b style={{ marginLeft: 10 }}> RM Name:</b>{" "}
                    {modalData?.userName} |
                    <b style={{ marginLeft: 10 }}> Party Name:</b>{" "}
                    {modalData?.schoolName} ({modalData?.partyId})
                </Typography>

                <IconButton
                    onClick={closePopup}
                    sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </div>

            {/* ================= OLD DATA ================= */}

            {historyLoading ? (

                <Box textAlign="center" py={3}>
                    <CircularProgress />
                </Box>

            ) :
                (
                    oldData.map((item, index) => (
                        <Paper
                            key={index}
                            elevation={2}
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: 2,
                                background: "#fafafa",
                            }}
                        >
                            <Typography
                                variant="subtitle1"
                                fontWeight={700}
                                mb={2}
                            >
                                Previous Entry {index + 1}
                            </Typography>

                            <Grid container spacing={2}>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        disabled
                                        label="Invoice Number"
                                        value={
                                            item?.study_material_invoice_no || ""
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        disabled
                                        label="Invoice Amount"
                                        value={
                                            item?.study_material_amount || ""
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        disabled
                                        type="date"
                                        label="Invoice Date"
                                        value={
                                            item?.study_material_invoice_date
                                                ? item?.study_material_invoice_date?.split(
                                                    "T"
                                                )[0]
                                                : ""
                                        }
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    ))
                )
            }

            {/* ================= NEW ENTRY FORM ================= */}

            <Paper
                elevation={3}
                sx={{
                    p: 3,
                    borderRadius: 3,
                }}
            >
                <Typography
                    variant="h6"
                    fontWeight={700}
                    mb={3}
                >
                    Add New Entry
                </Typography>

                <Grid container spacing={3}>

                    {/* Invoice No */}
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Invoice Number"
                            name="study_material_invoice_no"
                            value={
                                formData.study_material_invoice_no
                            }
                            onChange={handleChange}
                        />
                    </Grid>

                    {/* Amount */}
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            size="small"
                            type="number"
                            label="Invoice Amount"
                            name="study_material_invoiced_amount"
                            value={
                                formData.study_material_invoiced_amount
                            }
                            onChange={handleChange}
                        />
                    </Grid>

                    {/* Date */}
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            size="small"
                            type="date"
                            label="Invoice Date"
                            name="study_material_invoice_date"
                            value={
                                formData.study_material_invoice_date
                            }
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    {/* FILE UPLOAD */}
                    <Grid item xs={12}>

                        <Button
                            variant="outlined"
                            component="label"
                            startIcon={<UploadFileIcon />}
                        >
                            Upload Attachment

                            <input
                                hidden
                                multiple
                                type="file"
                                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                onChange={handleFileUpload}
                            />
                        </Button>

                        {/* ATTACHMENT PREVIEW */}

                        {attachmentData.length > 0 && (
                            <Box mt={3}>
                                <Grid container spacing={2}>

                                    {attachmentData.map((att, index) => {

                                        const isImage =
                                            att?.type?.startsWith("image");

                                        return (
                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={3}
                                                key={index}
                                            >
                                                <Paper
                                                    elevation={2}
                                                    sx={{
                                                        p: 1,
                                                        borderRadius: 2,
                                                        position: "relative",
                                                        overflow: "hidden",
                                                    }}
                                                >

                                                    {/* REMOVE BUTTON */}

                                                    <Tooltip title="Remove">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                                handleRemoveAttachment(
                                                                    index
                                                                )
                                                            }
                                                            sx={{
                                                                position:
                                                                    "absolute",
                                                                top: 5,
                                                                right: 5,
                                                                zIndex: 2,
                                                                background:
                                                                    "#fff",
                                                            }}
                                                        >
                                                            <DeleteIcon
                                                                fontSize="small"
                                                                color="error"
                                                            />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {/* IMAGE / FILE */}

                                                    {isImage ? (
                                                        <img
                                                            src={att.preview}
                                                            alt={att.name}
                                                            onClick={() =>
                                                                setPreviewImage(
                                                                    att.preview
                                                                )
                                                            }
                                                            style={{
                                                                width: "100%",
                                                                height: "140px",
                                                                objectFit:
                                                                    "cover",
                                                                borderRadius:
                                                                    "8px",
                                                                cursor:
                                                                    "pointer",
                                                            }}
                                                        />
                                                    ) : (
                                                        <Box
                                                            sx={{
                                                                height: "140px",
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                                background:
                                                                    "#f5f5f5",
                                                                borderRadius:
                                                                    "8px",
                                                            }}
                                                        >
                                                            <ImageIcon
                                                                sx={{
                                                                    fontSize:
                                                                        50,
                                                                    color:
                                                                        "#999",
                                                                }}
                                                            />
                                                        </Box>
                                                    )}

                                                    {/* FILE NAME */}

                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            mt: 1,
                                                            display: "block",
                                                            textAlign: "center",
                                                            wordBreak:
                                                                "break-word",
                                                        }}
                                                    >
                                                        {att.name}
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Box>
                        )}
                    </Grid>

                    {/* ACTION BUTTONS */}

                    <Grid item xs={12}>
                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            gap={2}
                            mt={2}
                        >
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={closePopup}
                                disabled={loading}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? (
                                    <CircularProgress
                                        size={22}
                                        color="inherit"
                                    />
                                ) : (
                                    "Submit"
                                )}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* ================= IMAGE PREVIEW ================= */}

            <Dialog
                open={!!previewImage}
                onClose={() => setPreviewImage(null)}
                maxWidth="md"
            >
                <DialogTitle>
                    Attachment Preview

                    <IconButton
                        onClick={() => setPreviewImage(null)}
                        sx={{
                            position: "absolute",
                            right: 10,
                            top: 10,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    {previewImage && (
                        <img
                            src={previewImage}
                            alt="preview"
                            style={{
                                width: "100%",
                                borderRadius: "10px",
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default AddInvoiceOlympiad;